module.exports = __webpack_public_path__ + "img/28_21.6fb4dfb1.png";